import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { fetchDataDomain, deleteDataDomain } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import DetailSection from "../../components/common/DetailSection";
import DetailField from "../../components/common/DetailField";
import ConfirmDialog from "../../components/common/ConfirmDialog";

export default function DataDomainDetailPage() {
  const { businessDomainId, dataDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [data, setData] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try { setData(await fetchDataDomain(dataDomainId)); }
      catch (e) { notify.apiError(e); }
    })();
  }, [dataDomainId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDelete = async () => {
    try {
      await deleteDataDomain(dataDomainId);
      notify.success(t("message.delete.success"));
      navigate(`/design/${businessDomainId}/data-domains`);
    } catch (e) { notify.apiError(e); }
  };

  if (!data) return null;
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("dataDomain.detail.title")}</Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button variant="contained" startIcon={<EditIcon />}
            onClick={() => navigate(`/design/${businessDomainId}/data-domains/${dataDomainId}/edit`)}>
            {t("common.edit")}
          </Button>
          <Button variant="contained" color="error" startIcon={<DeleteIcon />}
            onClick={() => setConfirmOpen(true)}>
            {t("common.delete")}
          </Button>
        </Box>
      </Box>
      <DetailSection>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <DetailField label={t("dataDomain.name")} value={data.dataDomainName} />
          </Grid>
          <Grid size={12}>
            <DetailField label={t("common.description")} value={data.dataDomainDescription} />
          </Grid>
        </Grid>
      </DetailSection>
      <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/data-domains`)}>
        {t("common.back")}
      </Button>
      <ConfirmDialog open={confirmOpen} onConfirm={handleDelete} onCancel={() => setConfirmOpen(false)} />
    </Box>
  );
}
